import React from 'react'

import { SuspendedControl } from '../../../utils/SuspendedControl'
import { MultipleChoiceImageSkeleton } from '../skeletons'

/**
 * Renders a Suspense-enabled version of MultichoiceImageButtonControl
 */
export const SuspendedMultipleChoiceImageButton = SuspendedControl(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  React.lazy(() => import('../MultipleChoiceImageButton') as any),
  MultipleChoiceImageSkeleton
)
